import React from "react";
import { ScanFlowV2 } from "crossdock/common/flow/ScanFlowV2";
import { createScanInboundPalletCard } from "../InboundPalletLabelCardCreators";

export const MovePallet: React.FC = () => <ScanFlowV2 onMountCardData={createScanInboundPalletCard({})} />;
